import React, { useEffect, useState } from "react";
import OverviewSection from "./overview";
import UnitsSection from "./units";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import MaintenanceRequestSection from "../../home/maintainance-request";
import ReceivePayment from "../../home/receivePayment";
import LeaseTableSection from "../property-detail/leaseSection";
import ImageCarousel from "../property-detail/image-carousel";
import PropertyTransactionsSection from "./transactionsSection";
import TransactionsTable from "../../home/transactionsTable";
import db from "../../../../db/index.json";
import BaseUrl from "../../../../constants/BaseUrl";
import MyLoader from "../../../reusebale/myLoader";
import { Plus } from "lucide-react";
import ParagraphTag from "../../../../component/reusebale/Paragraph";
import LeaseSummaryReportPopup from "../../../reports/LeaseSummryReportPopup";
import PropertyLoader from "../../../skeleton-loader/propety-detail";
import AccountWalletTile from "./AccountWalletTile";
import { useSelector } from "react-redux";
const MainSection = ({
  onBack,
  propertyId,
  onViewDetailsMaintain,
  onMaintainancePage,
  onCreateLease,
  toggleLeaseDetail,
  toggleTenantTable,
}) => {
  const [allDetails, setAllDetails] = useState();
  const [loader, setLoader] = useState();
  const [showTransactions, setShowTransactions] = useState(false);
  const { properties } = db;
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetPropertyDetails = () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/property/getPropertyDetails/${propertyId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setLoader(false);
          setAllDetails(result.data);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => console.error(error));
  };

  const [showReport, setShowReport] = useState(false);
  const [reportData, setReportData] = useState([]);

  const GetAllReportData = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/lease/getAllLeaseByProperty/${propertyId}?page=1&limit=500`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          console.log("RESULT DATA", result.data);
          setReportData(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetPropertyDetails();
    GetAllReportData();
  }, [propertyId]);

  if (showTransactions) {
    return (
      <TransactionsTable
        onBack={() => setShowTransactions(false)}
        propertyId={propertyId}
      />
    );
  }

  // if (loader) {
  //   return (
  //     <div className="flex h-screen justify-center items-center">
  //       <MyLoader />
  //     </div>
  //   );
  // } else {
  return (
    <div className="mb-8">
      <div className="mt-6 w-full flex">
        <div className="w-[80%]">
          <Breadcrumbs
            classes={`text-darkColor font-popinsSemiBold text-lg`}
            recordId={`PROP-${allDetails?._id?.slice(1, 10)}`}
            subheading="Property Details"
            onBack={onBack}
          />
        </div>

        <div className="w-[20%] flex justify-end">
          <button
            className="w-full bg-themeColor font-popinsMedium rounded-md flex items-center justify-center py-2"
            onClick={() => {
              setShowReport(true);
            }}
          >
            <ParagraphTag
              content="Show Report"
              classes="text-white font-popinsSemiBold text-xs pl-2"
              onTrigger={() => {
                setShowReport(true);
              }}
            />
          </button>
        </div>
      </div>
      {loader && <PropertyLoader />}
      {!loader && (
        <>
          <OverviewSection allDetails={allDetails} />
          <div className="flex gap-4 mt-5 items-start">
            <div className="w-[49%]">
              <AccountWalletTile propertyId={propertyId} />
            </div>
            <div className="w-[49%] bg-white rounded-lg px-5 py-5">
              <p className="text-darkColor font-popinsSemiBold text-lg mb-4">Recent Leases</p>
              {reportData.length === 0 ? (
                <p className="text-darkColor/40 font-popinsRegular text-sm">N/A</p>
              ) : (
                <div className="flex flex-col gap-2">
                  {reportData.slice(0, 5).map((lease, i) => (
                    <div key={i} className="flex justify-between items-center border-b border-gray-100 pb-2 last:border-0">
                      <div>
                        <p className="text-darkColor font-popinsMedium text-sm">
                          {lease?.tenantData?.userName || "N/A"}
                        </p>
                        <p className="text-darkColor/40 font-popinsRegular text-xs">
                          {lease?.unitData?.unitName || "N/A"} · {lease?.leaseStart ? new Date(lease.leaseStart).toLocaleDateString("en-US") : "N/A"}
                        </p>
                      </div>
                      <p className="text-themeColor font-popinsSemiBold text-sm">
                        ${(Number(lease?.rentAmount) || 0).toLocaleString()}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>


          <UnitsSection allDetails={allDetails} />
          <div className="flex justify-between mt-4">
            <div className="w-[49%]">
              <MaintenanceRequestSection
                propertyId={propertyId}
                onViewDetails={onViewDetailsMaintain}
                onMaintainanceTable={onMaintainancePage}
              />
            </div>
            <div className="w-[49%]">
              <ReceivePayment 
                handleTenantaTable={toggleTenantTable} 
                propertyId={propertyId}
                onViewAllTransactions={() => {
                  setShowTransactions(true);
                }}
              />
            </div>
          </div>
          <LeaseTableSection
            propertyId={propertyId}
            createLease={onCreateLease}
            isViewDetails={toggleLeaseDetail}
          />
          <PropertyTransactionsSection propertyId={propertyId} />
          <LeaseSummaryReportPopup
            PropertyName={allDetails?.propertyName}
            onClose={() => setShowReport(false)}
            isOpen={showReport}
            allData={reportData}
          />
        </>
      )}
    </div>
  );
};
// };

export default MainSection;
